import "./i18n/index";
import "@fontsource/roboto/100.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";
import "@fontsource/roboto/100-italic.css";
import "@fontsource/roboto/300-italic.css";
import "@fontsource/roboto/400-italic.css";
import "@fontsource/roboto/500-italic.css";
import "@fontsource/roboto/700-italic.css";
import "@fontsource/roboto/900-italic.css";
import "@fontsource/nunito/200-italic.css";
import "@fontsource/nunito/200.css";
import "@fontsource/nunito/300-italic.css";
import "@fontsource/nunito/300.css";
import "@fontsource/nunito/400-italic.css";
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/500-italic.css";
import "@fontsource/nunito/500.css";
import "@fontsource/nunito/600-italic.css";
import "@fontsource/nunito/600.css";
import "@fontsource/nunito/700-italic.css";
import "@fontsource/nunito/700.css";
import "@fontsource/nunito/800-italic.css";
import "@fontsource/nunito/800.css";
import "@fontsource/nunito/900-italic.css";
import "@fontsource/nunito/900.css";
import "@fontsource-variable/nunito";
import "@/utils/styles/global.css";

import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { useAuth } from "react-oidc-context";

import { ThemeContextProvider } from "@/contexts/styles/theme";

import { getQueryClient } from "./api/graphql/client";
import { AuthenticationContext } from "./contexts/authentication";
import { SnackbarContextProvider } from "./contexts/snackbar";
// Import the generated route tree
import { routeTree } from "./routeTree.gen";
// Create a new router instance
const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
    roles: undefined!,
  },
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

function RouterProviderWithContext() {
  const auth = useAuth();
  //TODO: Obtain the loged user roles here to pass them in the context
  return (
    <RouterProvider
      router={router}
      context={{ auth, roles: ["agent", "super-agent"] }}
    />
  );
}

// Render the app
const rootElement = document.getElementById("app")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  const queryClient = getQueryClient();

  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthenticationContext>
          <ThemeContextProvider>
            <SnackbarContextProvider>
              <RouterProviderWithContext />
            </SnackbarContextProvider>
          </ThemeContextProvider>
        </AuthenticationContext>
      </QueryClientProvider>
    </StrictMode>,
  );
}
